import PropTypes from 'prop-types'
import clsx from 'clsx'
import Link from 'next/link'
import Typo from 'constants/typography'
import { parseCyKey } from 'lib/utils/cypress'
import { withI18next } from 'lib/i18n/withI18next'
import React, { useState } from 'react'
import CountrySelectDrawer from 'components/header/country-select-drawer/CountrySelectDrawer'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { onLinkClicked } from '../utils'

const UserLogoutOption = ({
  t,
  link,
  isPhone,
  optionIndex,
  currentPage,
  onClickSignOut,
}) => {
  const [isOpenCountrySelectDrawer, setIsOpenCountrySelectDrawer] =
    useState(false)

  if (link.type === 'title') {
    return (
      <span
        className={clsx(Typo.subtitle2, 'navigation-title')}
        data-cy={parseCyKey(`user_options_${link.label}`)}
      >
        {t(link.label)}
      </span>
    )
  }

  if (link.type === 'action' && link.code === 'language') {
    return (
      <CountrySelectDrawer
        isShowCloseDrawer={!isPhone}
        isOpenDrawer={isOpenCountrySelectDrawer}
        onCloseDrawer={() =>
          setIsOpenCountrySelectDrawer(!isOpenCountrySelectDrawer)
        }
        onClickBack={
          isPhone
            ? () => setIsOpenCountrySelectDrawer(!isOpenCountrySelectDrawer)
            : null
        }
        countryDrawerTrigger={
          <span
            tabIndex="0"
            role="button"
            onClick={() =>
              setIsOpenCountrySelectDrawer(!isOpenCountrySelectDrawer)
            }
            onKeyDown={() =>
              setIsOpenCountrySelectDrawer(!isOpenCountrySelectDrawer)
            }
            className={clsx(Typo.body2, 'navigation-link')}
            data-cy={parseCyKey(`user_options_${link.label}`)}
          >
            {t(link.label)}
          </span>
        }
      />
    )
  }

  if (link.type === 'action' && link.action === 'logout') {
    return (
      <span
        className={clsx(Typo.body2, 'navigation-link', { logout: true })}
        onClick={onClickSignOut}
        onKeyDown={onClickSignOut}
        role="button"
        tabIndex="0"
        data-cy={parseCyKey(`user_options_${link.label}`)}
      >
        {t(link.label)}
      </span>
    )
  }

  return (
    <Link href={link.href} as={link.as}>
      <a
        data-cy={parseCyKey(`user_options_${link.label}`)}
        className={clsx('navigation-link', Typo.body2, {
          active: link.code === currentPage,
        })}
        onClickCapture={() =>
          onLinkClicked(link.trackingSessionKey, optionIndex)
        }
      >
        {t(link.label)}
      </a>
    </Link>
  )
}

UserLogoutOption.propTypes = {
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
  link: PropTypes.shape({
    href: PropTypes.string,
    as: PropTypes.string,
    type: PropTypes.string,
    code: PropTypes.string,
    label: PropTypes.string,
    action: PropTypes.string,
    trackingSessionKey: PropTypes.string,
  }).isRequired,
  currentPage: PropTypes.string.isRequired,
  optionIndex: PropTypes.number.isRequired,
  onClickSignOut: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
  })),
  withI18next(),
)(UserLogoutOption)
